import { authErrorHandler } from './errorHandlerAuth';
import {
  getAccessToken,
  clearUserToken,
  getSubId,
  isValidAccessToken,
  setAccessToken,
} from '@devhacker/shared/features/auth/utils/token';
import { normalizeUserData } from '~/libs/normalizeUserData';
import { useIndexStore } from '~/store';
import { useTalkerStore } from '@devhacker/shared/plugins/talker/store/talker';
import { refreshTokenSingleFlight } from '@devhacker/shared/features/auth/utils/refreshSingleFlight';
import { isRefreshConflict } from '@devhacker/shared/features/auth/utils/crossTabRefresh';

export async function authRequestInterceptor(config: any, moduleName?: string) {
  if (import.meta.server) return;

  const indexStore = useIndexStore();
  const talkerStore = useTalkerStore();

  const accessToken = getAccessToken();

  if (accessToken && !isValidAccessToken(accessToken)) {
    try {
      const result = await refreshTokenSingleFlight();

      if (result.access_token) {
        setAccessToken(result.access_token);
      } else {
        console.warn('Interceptor: refresh returned empty access_token, clearing session');
        clearUserToken();
        indexStore.clearUserAndRelatedData();
      }

      const userDataCurrent = indexStore.user;

      const subId = getSubId(accessToken);
      if (!userDataCurrent && !indexStore.isUserLoading && subId) {
        await indexStore.fetchUser(subId);
        const updatedUser = indexStore.user;
        if (updatedUser) {
          talkerStore.setUser(normalizeUserData(updatedUser));
        }
      }
    } catch (error) {
      if (isRefreshConflict(error)) {
        console.warn('Interceptor: access token refresh conflict, request aborted, session kept');
        throw error;
      }
      authErrorHandler(error, moduleName);
    }
  }

  const accessTokenActual = getAccessToken();
  if (accessTokenActual) {
    config.options.headers.set('Authorization', `Bearer ${accessTokenActual}`);
  }
}
